/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {

  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    this.button = document.getElementById('Facets-Toggle');

    if (!this.container || !this.button) return;

    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('open-cc');
      this.container.classList.add('active');
    });

    document.addEventListener('click', (event) => {
      const isDrawerOpen = document.body.classList.contains('open-cc');
      const clickedInsideDrawer = event.target.closest('#Facet-Drawer');
      const clickedToggleButton = event.target.closest('#Facets-Toggle');

      if (!isDrawerOpen) return;

      if (!clickedInsideDrawer && !clickedToggleButton) {
        this.closeDrawer();
      }
    });

    setTimeout(() => {
      window.dispatchEvent(new Event('resize.resize-select'));
    }, 10);
  }

  closeDrawer() {
    document.body.classList.remove('open-cc');
    this.container.classList.remove('active');
  }
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', (event) => {
  // Skip client-side-only inputs (the per-filter search box, size tabs, etc.)
  if (event.target.classList.contains('facets__search-input')) return;
  // Skip manual price inputs — these submit on change/blur/Enter instead of every keystroke
  if (event.target.classList.contains('field__input_min') || event.target.classList.contains('field__input_max')) return;
  this.debouncedOnSubmit(event);
});

    this.querySelector('form').addEventListener('change', (event) => {
  if (!event.target.classList.contains('field__input_min') && !event.target.classList.contains('field__input_max')) return;
  this.onSubmitHandler(event);
});
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    // Availability filter is always applied and hidden from the UI
    if (!/(^|&)filter\.v\.availability=1(&|$)/.test(searchParams)) {
      searchParams += (searchParams ? '&' : '') + 'filter.v.availability=1';
    }
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        new FacetsToggle();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    new FacetsToggle();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML =
      new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    // let top =
    //   document.getElementById('ProductGridContainer').getBoundingClientRect().top +
    //   document.documentElement.scrollTop -
    //   parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) -
    //   30;

    // window.scrollTo({ top, left: 0, behavior: 'smooth' });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const newCount = parsed.getElementById('ProductCount');

    document.dispatchEvent(
      new CustomEvent('facet:product-count-updated', {
        detail: { html: newCount?.innerHTML || '' },
      })
    );
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const parentId = element.closest('#FacetFiltersFormMobile')
        ? '#FacetFiltersFormMobile'
        : '#FacetFiltersForm';
      const target = document.querySelector(
        `${parentId} collapsible-row[data-index="${element.dataset.index}"]`
      );
      if (target) target.innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    new FacetsToggle();

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const target = document.querySelector(selector);
      if (!target) return;
      target.innerHTML = activeFacetsElement.innerHTML;
    });
    FacetFiltersForm.toggleActiveFacets(false);

    // ★ FIX #5: notify size chip label updater after active filters re-render
    document.dispatchEvent(new CustomEvent('facet:active-filters-rendered'));
  }

  // ★ UPDATED — also syncs .selected-filters-header (chip row in drawer header)
  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      '.mobile-filter-count',
      '.facet-drawer .side-panel-footer',
      '.selected-filters-header',
    ];

    mobileElementSelectors.forEach((selector) => {
      const sourceEl = html.querySelector(selector);
      const targetEl = document.querySelector(selector);
      if (!sourceEl || !targetEl) return;

      targetEl.innerHTML = sourceEl.innerHTML;

      if (sourceEl.className !== targetEl.className) {
        targetEl.className = sourceEl.className;
      }
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');
    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML =
        source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    );
  }

  static getSections() {
    return [{ section: document.getElementById('product-grid').dataset.id }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);

    const currentSort = new URLSearchParams(window.location.search).get('sort_by');
    if (currentSort && !searchParams.get('sort_by')) {
      searchParams.set('sort_by', currentSort);
    }

    if (searchParams.get('filter.v.price.gte') === '0.00') {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (
        searchParams.get('filter.v.price.lte') ===
        parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)
      ) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') === -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const form =
          this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}
customElements.define('facet-remove', FacetRemove);


/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [
          parseFloat(slider.dataset.minValue || 0),
          parseFloat(slider.dataset.maxValue || slider.dataset.max),
        ],
        connect: true,
        step: 10,
        direction: document.dir,
        handleAttributes: [{ 'aria-label': 'lower' }, { 'aria-label': 'upper' }],
        range: { min: 0, max: parseFloat(slider.dataset.max) },
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function () {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

window.addEventListener('load', () => {
  new FacetsToggle();
});


// Custom sort-by option
(function () {
  const findFacetForm = (el) =>
    el.closest('facet-filters-form')?.querySelector('form') ||
    document.querySelector('#FacetFiltersForm-bar form');

  const triggerSelect = (select, value) => {
    select.value = value;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  };

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('.custom-sort__toggle');
    if (toggle) {
      e.stopPropagation();
      const component = toggle.closest('.custom-sort');
      const list = component.querySelector('.custom-sort__list');
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !open);
      list.hidden = open;
      return;
    }

    const item = e.target.closest('.custom-sort__item');
    if (item) {
      e.stopPropagation();
      const comp = item.closest('.custom-sort');
      const label = comp.querySelector('#SortLabel');
      if (label) label.textContent = item.dataset.name;

      comp.querySelectorAll('.custom-sort__item').forEach(i => i.classList.remove('active'));
      item.classList.add('active');

      const form = findFacetForm(comp);
      const realSelect = form?.querySelector('select[name="sort_by"]');

      if (realSelect) {
        triggerSelect(realSelect, item.dataset.value);
      } else {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', item.dataset.value);
        window.location.href = url.toString();
      }

      comp.querySelector('.custom-sort__toggle').setAttribute('aria-expanded', 'false');
      comp.querySelector('.custom-sort__list').hidden = true;
      return;
    }

    document.querySelectorAll('.custom-sort__toggle[aria-expanded="true"]').forEach(t => {
      t.setAttribute('aria-expanded', 'false');
      t.closest('.custom-sort').querySelector('.custom-sort__list').hidden = true;
    });
  });
})();


document.addEventListener('facet:updated', () => {
  const original = document.querySelector('#ProductCount');
  const mirror = document.querySelector('#ProductCountMirror');
  if (original && mirror) {
    mirror.innerHTML = '(' + original.innerHTML + ')';
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const original = document.querySelector('#ProductCount');
  const mirror = document.querySelector('#ProductCountMirror');
  if (original && mirror) {
    mirror.innerHTML = '(' + original.innerHTML + ')';
  }
});

// Price input — disable alphabetic input, apply filter only once entry is complete
document.addEventListener('DOMContentLoaded', function () {
  const minInput = document.querySelector('.field__input_min');
  const maxInput = document.querySelector('.field__input_max');

  function allowOnlyNumbersAndDecimals(e) {
    e.target.value = e.target.value.replace(/[^0-9.,]/g, '');
  }

  function commitOnEnter(e) {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    e.target.blur();
    e.target.dispatchEvent(new Event('change', { bubbles: true }));
  }

  [minInput, maxInput].forEach((input) => {
    if (!input) return;
    input.addEventListener('input', allowOnlyNumbersAndDecimals);
    input.addEventListener('keydown', commitOnEnter);
  });
});

// ★ UPDATED — product count listener (mirror for grid header + apply button)
document.addEventListener('facet:product-count-updated', (e) => {
  const mirror = document.getElementById('ProductCountMirror');
  if (mirror && e.detail?.html) {
    mirror.innerHTML = '(' + e.detail.html + ')';
  }
});